export enum TutorBillingFlag {
  Checked = 'is_checked',
  AgreementSent = 'is_agreement_sent',
  AgreementSigned = 'is_agreement_signed',
  SalesforceAccount = 'has_salesforce_account',
  IssuesDetected = 'has_issues_detected',
}

export enum TutorBillingChangeType {
  NewAccount = 'NEW_ACCOUNT',
  ChangePending = 'CHANGE_PENDING',
}

export enum TutorBillingDatePreset {
  Today = 'today',
  Yesterday = 'yesterday',
  Last7Days = 'last_7_days',
  Last30Days = 'last_30_days',
  ThisMonth = 'this_month',
  LastMonth = 'last_month',
  ThisYear = 'this_year',
  Custom = 'custom',
}

export enum TutorBillingModal {
  View = 'view',
  Erase = 'erase',
  NewAccount = 'new-account',
  ChangeRequest = 'change-request',
  BulkFlags = 'bulk-flags',
  BulkConfirm = 'bulk-confirm',
  BulkErase = 'bulk-erase',
  Export = 'export',
}

export enum TutorBillingPaymentService {
  Gcash = 'GCASH',
  Paypal = 'PAYPAL',
  Payoneer = 'PAYONEER',
  Wire = 'WIRE',
}
